import {
  ballInitialCircularMovement,
  ballJumpAnimationOnRouletteDisk,
  ballState, startFallBall,
  updateBallPositionForKeepSameNumberOnRouletteDisk,
} from "./ball";
import { circle1 } from "./circles";
import { getNumberAngle } from "./utils";
import { cameraPos1, cameraPos2, SCENE_OBJ_NAMES } from "./constants";
import { cameraConfigs, cameraPositionAnimation } from "./camera";
import { sceneObjects } from "./index";
import { rouletteDiskState } from "./rouletteDisk";
import { threeJsSounds } from "./threeJsSounds";


const setJumpPoints = (num, roundId) => {
  const jumpSteps = jumpStepsVariants[(num + roundId) % jumpStepsVariants.length];

  const targetAngle = getNumberAngle(num);
  const direction = rouletteDiskState.rotationDirection;

  for (let i = 1; i < jumpSteps.length; i++) {
    jumpPoints.push({
      startAngle: targetAngle + direction * jumpSteps[i - 1],
      endAngle: targetAngle + direction * jumpSteps[i],
      jumpSteps: jumpSteps[i],
      duration: 0.25,
    })
  }

}

export const jumpPoints = [];
export const spinState = {
  canSpin: true,
  setCanSpin: (bool) => spinState.canSpin = bool,
}

const initializeStatesForSpin = ({ isShortAnimation = false }) => {
  circle1.initialize();
  ballState.angleSpeed = ballState.fastSpeed;
  ballState.isInInitialCircularMovement = true;
  ballState.isStayOnRouletteDisk = false;
  ballState.traveledRotation = isShortAnimation ? ballState.minTravelIngRotation : 0;
  spinState.setCanSpin(false);
  jumpPoints.length = 0;
}

export const spin = async({ num, roundId = Math.floor(Math.random() * 10), isShortAnimation = false }) => {
  // if (!spinState.canSpin) {
  //   return;
  // }

  threeJsSounds.ballLoop();

  rouletteDiskState.rotationDirection *= -1;
  initializeStatesForSpin({ isShortAnimation });
  const camera = sceneObjects.get(SCENE_OBJ_NAMES.camera);

  if (cameraConfigs.movement.isAuto) {
    cameraPositionAnimation(camera, cameraPos2);
  }

  setJumpPoints(num, roundId);

  await ballInitialCircularMovement();

  await startFallBall(jumpPoints[0].startAngle);

  for (let i = 0; i < jumpPoints.length; i++) {
    await ballJumpAnimationOnRouletteDisk(jumpPoints[i]);
  }

  ballState.onBallAnimationComplete();

  ballState.isStayOnRouletteDisk = true;
  const targetAngle = getNumberAngle(num);
  updateBallPositionForKeepSameNumberOnRouletteDisk(targetAngle);

  setTimeout(() => {
    if (cameraConfigs.movement.isAuto) {
      cameraPositionAnimation(camera, cameraPos1);
    }
    spinState.setCanSpin(true);
  }, 1000)
}

const jumpStepsVariants = [
  [110, 70, 40, 15, 5, 0],
  [110, 70, 40, 15, -5, 0],
  [90, 50, 30, 20, 10, 0],
  [90, 50, 30, 20, 10, 3, -2, 0],
];

